module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/10ft-mobile-716446d06ae8b8e33b5e48fb0d7c4ca8.png";